// Passwortabfrage für den Admin-Modus
document.addEventListener('DOMContentLoaded', function() {
    // Holt das Formular und den Status des Admin-Modus
    const formToggleAdminMode = document.getElementById('toggle-admin-mode');
    const formCalendarDelete = document.getElementById('calendar-delete-form');
    const adminModeStatus = document.getElementById('admin-mode-status');

    // Prüft, ob das Formular existiert und der Admin-Modus aktiviert ist
    if (formToggleAdminMode && adminModeStatus) {
        formToggleAdminMode.addEventListener('submit', function(event) {
            // Prüft den aktuellen Status des Admin-Modus
            const status = adminModeStatus.getAttribute('value');

            // Nur wenn der Admin-Modus deaktiviert ist, wird das Passwort abgefragt
            if (!status) {
                event.preventDefault(); // Verhindert das Absenden, bis das Passwort eingegeben wurde
                openPasswordPrompt(formToggleAdminMode, 'Admin-Modus');
            }
        });
    }
    if (formCalendarDelete) {
        formCalendarDelete.addEventListener('submit', function(event) {
            event.preventDefault(); // Verhindert das Absenden, bis das Passwort eingegeben wurde
            openPasswordPrompt(formCalendarDelete, 'Kalender löschen', 'Gib "löschen" ein');
        });
    }

    // Öffnet ein modales Eingabefenster für das Passwort
    function openPasswordPrompt(element, titleText, placeholderText = 'Passwort eingeben') {
        // Erstellt das Modal
        const modal = document.createElement('div');
        modal.style.position = 'fixed';
        modal.style.left = '50%';
        modal.style.top = '9rem';
        modal.style.transform = 'translate(-50%, -50%)';
        modal.style.marginTop = '5vh';
        modal.style.maxWidth = '90vw';
        modal.style.minWidth = '300px';
        modal.style.padding = '14px';
        modal.style.backgroundColor = '#fcfcfc';
        modal.style.border = '3px outset #ccc';
        modal.style.boxShadow = '0 0 0 9999px rgba(0,0,0,0.5)';
        modal.style.borderRadius = '10px';
        modal.style.zIndex = '1000';

        // scrollable modal
        modal.style.maxHeight = '81vh';
        modal.style.overflowY = 'auto';

        // Titel
        const title = document.createElement('h2');
        title.textContent = titleText;
        title.style.marginBottom = '6px';
        title.style.textAlign = 'center';
        title.style.fontSize = '18px';
        title.style.fontWeight = 'bold';

        // Hinweis (nur für das Löschen des Kalenders)
        const hintContainer = document.createElement('div');
        const hintLine1 = document.createElement('p');
        const hintLine2 = document.createElement('p');
        if (element.id === 'calendar-delete-form') {
            hintContainer.style.marginBottom = '10px';
            hintContainer.style.textAlign = 'center';
            hintContainer.style.color = 'red';

            hintLine1.textContent = 'Achtung: Das Löschen des Kalenders ist endgültig und kann nicht rückgängig gemacht werden!';
            hintLine2.textContent = 'Gib das Wort "löschen" ein, um den Kalender zu löschen.';

            hintLine1.style.marginBottom = '10px';
            hintLine2.style.color = 'blue';
        }

        // Passwortfeld
        const passwordInput = document.createElement('input');
        passwordInput.type = 'password';
        passwordInput.placeholder = placeholderText;
        passwordInput.style.display = 'block';
        passwordInput.style.marginBottom = '10px';
        passwordInput.style.width = '100%';
        passwordInput.style.padding = '5px 10px';
        passwordInput.style.border = '1px solid #ccc';
        passwordInput.style.borderRadius = '4px';
        passwordInput.style.boxShadow = '0px 1px 1px rgba(0,0,0,0.5)';

        // Bestätigungsbutton
        const confirmButton = document.createElement('button');
        confirmButton.textContent = 'Bestätigen';
        confirmButton.style.display = 'block';
        confirmButton.style.width = '100%';
        confirmButton.style.padding = '6px';
        confirmButton.style.backgroundColor = '#007BFF';
        confirmButton.style.color = 'white';
        confirmButton.style.border = 'none';
        confirmButton.style.borderRadius = '4px';
        confirmButton.style.cursor = 'pointer';
        confirmButton.style.boxShadow = '0px 1px 1px rgba(0,0,0,0.75)';
        // Add and remove hover effect
        confirmButton.addEventListener('mouseover', function() {
            confirmButton.style.backgroundColor = '#0070eb';
        });
        confirmButton.addEventListener('mouseout', function() {
            confirmButton.style.backgroundColor = '#007BFF';
        });

        // Abbruchbutton
        const cancelButton = document.createElement('button');
        cancelButton.textContent = 'Abbrechen';
        cancelButton.style.display = 'block';
        cancelButton.style.width = '100%';
        cancelButton.style.padding = '6px';
        cancelButton.style.backgroundColor = '#ddd';
        cancelButton.style.color = 'black';
        cancelButton.style.border = 'none';
        cancelButton.style.borderRadius = '4px';
        cancelButton.style.marginTop = '10px';
        cancelButton.style.cursor = 'pointer';
        cancelButton.style.boxShadow = '0px 1px 1px rgba(0,0,0,0.5)';
        // add and remove hover effect
        cancelButton.addEventListener('mouseover', function() {
            cancelButton.style.backgroundColor = '#d4d4d4';
        });
        cancelButton.addEventListener('mouseout', function() {
            cancelButton.style.backgroundColor = '#ddd';
        });

        // Fügt die Elemente ins Modal ein
        if (element.id === 'calendar-delete-form') {
            modal.appendChild(hintContainer);
            hintContainer.appendChild(hintLine1);
            hintContainer.appendChild(hintLine2);
        }
        modal.appendChild(title);
        modal.appendChild(passwordInput);
        modal.appendChild(confirmButton);
        modal.appendChild(cancelButton);
        document.body.appendChild(modal);

        // Fokus direkt auf das Passwortfeld setzen
        passwordInput.focus();

        // Event: Bestätigen
        confirmButton.addEventListener('click', function() {
            const password = passwordInput.value;
            if (password) {
                // Suche innerhalb des übergebenen Elements nach einem Input-Feld mit "password" im ID-Namen
                const passwordField = element.querySelector('input[type="hidden"][id*="password"]');
                if (passwordField) {
                    passwordField.value = password;
                }
                else{
                    alert ('Es wurde kein Feld mit "password" im id-Namen gefunden.')
                }
                // document.getElementById('password').value = password;
                element.submit();
            }
            document.body.removeChild(modal); // Entfernt das Modal
        });

        // Event: Abbrechen
        cancelButton.addEventListener('click', function() {
            document.body.removeChild(modal); // Entfernt das Modal
        });

        // Event: Enter-Taste zum Absenden
        passwordInput.addEventListener('keypress', function(event) {
            if (event.key === 'Enter') {
                confirmButton.click();
            }
        });

        // Event: Escape-Taste zum Abbrechen
        document.addEventListener('keydown', function(event) {
            if (event.key === 'Escape') {
                if (document.body.contains(modal)) {
                    document.body.removeChild(modal); // Entfernt das Modal
                }
            }
        });
    }
});
